import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { ConfirmationService } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import {AppSettingService} from '../../_services/app-setting.service';
import {forkJoin} from 'rxjs';
import {GarantiasIdoneas} from '../../_models/garantias-idoneas';
import {GarantiaIdoneasService} from '../../_services/garantia-idoneas.service';
import {TiposProductores} from '../../_models/tipos-productores';
import {TipoProductoresService} from '../../_services/tipo-producto.service';
import {SegmentoIngreso} from '../../_models/segmento-ingreso';

@Component( {
  selector: 'app-tipo-productores-editar',
  templateUrl: 'tipo-productores-editar.component.html'
} )

export class TipoProductoresEditarComponent implements OnInit {

  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  tiposProductores: TiposProductores;

  lisTiposProductores: TiposProductores[] = [];
  formulario: FormGroup;
  submitted = false;
  carTabla = true;
  rangoMontoValido = true;
  plazo = false;
  tasa = false;
  rangoInvalido = false;

  constructor( private tipoProductoresService: TipoProductoresService,
               private route: ActivatedRoute,
               private fb: FormBuilder,
               private location: Location,
               private conServicio: ConfirmationService,
               private navServicio: NavService,
               public appSettingService: AppSettingService) {
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.tipoProductoresService.obtenerPorId( params[ 'id' ] ).subscribe( paquete => {
          this.tiposProductores = paquete;
          this.cargarInformacionInicial();
        } );
      } else {
        this.cargarInformacionInicial();
      }
    } );
  }

  cargarInformacionInicial() {
    forkJoin(
      this.tipoProductoresService.listado()).
    subscribe( ( [ res1 ] ) => {
      this.lisTiposProductores = res1;
    }, ( err1 ) => {
      this.navServicio.setMesage( 4, {
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo cargar la información. Intente nuevamente.'
      } );
    } );

    this.formulario = this.fb.group( {
      idTipoProductor: [ this.tiposProductores ? this.tiposProductores.idTipoProductor : null ],
      codigo: [ this.tiposProductores ? this.tiposProductores.codigo : null, [ Validators.required ] ],
      nombre: [ this.tiposProductores ? this.tiposProductores.nombre : null, [ Validators.required ] ],
      rangoMinimo: [ this.tiposProductores ? this.tiposProductores.rangoMinimo : null, [ Validators.required ] ],
      rangoMaximo: [ this.tiposProductores ? this.tiposProductores.rangoMaximo : null, [ Validators.required ] ],
      indicadorHabilitado: [ this.tiposProductores ? this.tiposProductores.indicadorHabilitado : true],
    } );
    this.carInformacionInicial = false;
  }



  onSubmit() {
    this.submitted = true;
    this.rangoInvalido = this.validarRango();
    if ( !this.codExiste && this.formulario.valid && this.rangoMontoValido && this.rangoInvalido) {
      this.guardando = true;
      const formulario = this.formulario.getRawValue();

      if(formulario.idTipoProductor !== null && formulario.idTipoProductor !== undefined && formulario.idTipoProductor !== ''){
        if ( this.verificarNombre( formulario ) ) {
          this.navServicio.setMesage( 0, {
            severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.MSG_ERRORNOM' )
          } );
          this.guardando = false;
          this.submitted = false;
        } else {
          /** Actualizar  */
          this.tipoProductoresService.actualizar( formulario ).subscribe( plaga => {
            this.tiposProductores = plaga;
            this.submitted = false;
            this.guardando = false;
            this.navServicio.setMesage( 2 );
            this.location.back();
          } );
        }

      } else {
        if ( this.verificarCodigoYNombre( formulario ) ) {
          this.navServicio.setMesage( 0, {
            severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.MSG_ERRORCODNOM' )
          } );
          this.guardando = false;
          this.submitted = false;
        } else {
          /** Crear */
          this.tipoProductoresService.crear( formulario ).subscribe( paquete => {
            this.tiposProductores = paquete;
            this.f.idTipoProductor.setValue( this.tiposProductores.idTipoProductor );
            this.f.codigo.setValue( this.tiposProductores.codigo );
            this.submitted = false;
            this.guardando = false;
            this.navServicio.setMesage( 1 );
            this.location.back();
          } );
        }
      }
    }
  }



  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: `tipo-productores`,
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }


  validarValor( event: any, desde: boolean ) {
    const rangoDesde = this.formulario.controls.rangoMinimo.value;
    const rangoHasta = this.formulario.controls.rangoMaximo.value;
    if ( desde && rangoHasta ) {
      if ( Number( rangoDesde ) >= Number( rangoHasta ) ) {
        this.rangoMontoValido = false;
      } else {
        this.rangoMontoValido = true;
      }
    } else if ( !desde && rangoDesde ) {
      if ( Number( rangoDesde ) >= Number( rangoHasta ) ) {
        this.rangoMontoValido = false;
      } else {
        this.rangoMontoValido = true;
      }
    }
  }

  validarCodigo() {
    this.codExiste = this.lisTiposProductores.find( x => x.codigo === this.f.codigo.value ) ? true : false;
  }

  verificarNombre( item: TiposProductores ): boolean {
    return (this.lisTiposProductores.find( x => x.nombre === item.nombre && x.idTipoProductor
      !== item.idTipoProductor )) ? true : false;
  }

  verificarCodigoYNombre( item: TiposProductores ): boolean {
    return (this.lisTiposProductores.find( x => x.codigo === item.codigo || x.nombre === item.nombre )) ? true : false;
  }

  get f() {
    return this.formulario.controls;
  }

  validarRango(): boolean {
    const rangoDesde = Number( this.f.rangoMinimo.value);
    const rangoHasta = Number( this.f.rangoMaximo.value );
    const idTipoProductor = this.formulario.controls.idTipoProductor.value;
    let validacion = true;
    if(this.lisTiposProductores && this.lisTiposProductores.length >0){
      const dato1 = this.lisTiposProductores.find( x => x.rangoMinimo <= Number( rangoDesde ) && x.rangoMaximo > Number( rangoDesde ) && x.indicadorHabilitado);
      const dato2 = this.lisTiposProductores.find( x => x.rangoMinimo < Number( rangoHasta ) && x.rangoMaximo >= Number( rangoHasta ) && x.indicadorHabilitado );
      if ( (dato1 && dato1.idTipoProductor !== idTipoProductor && dato1.indicadorHabilitado)
        || (dato2 && dato2.idTipoProductor !== idTipoProductor && dato2.indicadorHabilitado) ) {
        validacion = false;
      } else {
        this.lisTiposProductores.map( ( s: TiposProductores ) => {
          if(s.indicadorHabilitado && s.idTipoProductor !== idTipoProductor){
            const datoMin = Number(s.rangoMinimo);
            const datohas = Number(s.rangoMaximo);
            if (rangoDesde > datoMin  && rangoDesde < datohas ){
              validacion = false;
            }
            if ( rangoHasta > datoMin && rangoHasta < datohas ){
              validacion = false;
            }
            if ( datoMin > rangoDesde && datoMin < rangoHasta ){
              validacion = false;
            }
          }
        } );
      }
    }
    return validacion;
  }


}
